import { dashboardApiMiddleware } from "src/api";

export const getHealth = dashboardApiMiddleware<string>()({
  method: "get",
  endpoint: "/api/health",
});
